/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { getCurrentPageIndex } from "selectors/pageNumber";

export const getIsThumbnailSelected = (stores, pageIndex) => {
  const organizeStore = stores.organizeStore;
  const dataSource = organizeStore.dataSource;
  if (!dataSource) return false;
  const id = dataSource.getIdFromIndex(pageIndex);
  return organizeStore.selectedSet.has(id);
};

export const isCurrPageThumbnail = (stores, pageIndex) => pageIndex === getCurrentPageIndex(stores);

export const getSelectedSet = stores => {
  const organizeStore = stores.organizeStore;
  return organizeStore.selectedSet;
};

export const getInsertPdfProgressLoaderIndex = stores => {
  const organizeStore = stores.organizeStore;
  return organizeStore.insertPdfProgressLoaderIndex;
};

export const getIndicesFromKeys = (stores, keys) => {
  const organizeStore = stores.organizeStore;
  const dataSource = organizeStore.dataSource;
  return keys.map(key => dataSource.getIndexFromId(key));
};

export const getKeyFromIndex = (stores, index) => {
  const organizeStore = stores.organizeStore;
  const dataSource = organizeStore.dataSource;
  return dataSource.getIdFromIndex(index);
};

export const getThumbnailDataSource = stores => stores.organizeStore.dataSource;

export const getIsOrganizeOpInProgress = stores => stores.organizeStore.isOrganizeOpInProgress;

export const getThumbnailsGridLayout = stores => stores.organizeStore.gridLayout;

export const getNumThumbnailsSelected = stores => stores.organizeStore.selectedSet.size;

export const getShouldShowInsertLoader = (stores, target) => {
  const key = target.key;
  const organizeStore = stores.organizeStore;
  const dataSource = organizeStore.dataSource;
  const index = dataSource.getIndexFromId(key);
  if (target.insertPosition === "before") {
    return index === getInsertPdfProgressLoaderIndex(stores);
  } else if (target.insertPosition === "after") {
    // after will come only if we are plaaning to insert after the last item in the list
    return dataSource.list.items.length === getInsertPdfProgressLoaderIndex(stores);
  }
  return false;
};
